import { GridColumnFilterButton } from '../../../components/shared/GridColumnFilterPanel';
import { GridExportButton, GridSearchInput } from '../../../components/shared/GridToolbar';

type MerchantToolbarProps = {
  search: string;
  onSearchChange: (value: string) => void;
  activeColumnFilterCount: number;
  onOpenFilters: () => void;
  onExport: () => void;
  exporting: boolean;
  loading: boolean;
  hasRows: boolean;
};

export default function MerchantToolbar({
  search,
  onSearchChange,
  activeColumnFilterCount,
  onOpenFilters,
  onExport,
  exporting,
  loading,
  hasRows,
}: MerchantToolbarProps) {
  return (
    <div className="tm-toolbar-controls">
      <GridSearchInput
        value={search}
        onValueChange={onSearchChange}
        placeholder="Search name, email or country…"
        inputClassName="text-xs font-normal tm-toolbar-search-input"
        className="tm-toolbar-search"
        disabled={loading}
      />
      <GridColumnFilterButton
        activeCount={activeColumnFilterCount}
        onClick={onOpenFilters}
        disabled={loading}
        className="tm-compact-icon-btn"
      />
      <GridExportButton
        onClick={onExport}
        loading={exporting}
        disabled={loading || !hasRows}
        className="tm-compact-icon-btn"
      />
    </div>
  );
}
